import { cn } from '@/components/default/lib/utils'; // if you're using class merging helpers

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
}

export function Button({ children, className, ...props }: ButtonProps) {
    return (
        <button className={cn('px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700', className)} {...props}>
            {children}
        </button>
    );
}
